import React from 'react';
import { IDocument } from '@cyntler/react-doc-viewer';

import { Alert, DialogContentText } from '@mui/material';

import useLocales from '../../hooks/useLocales';
import DocumentViewerDialog from './DocumentViewerDialog';
import { AccompanyingDocumentProps } from '../../@types/documents/types';

type DocumentAccompanyingDocumentViewerDialogProps = {
  isViewerDialogOpen: boolean;
  setIsViewerDialogOpen: (isOpen: boolean) => void;
  docs: IDocument[];
  accompanyingDocument: AccompanyingDocumentProps;
  handleToggleHasSeen: () => void;
};

const DocumentAccompanyingDocumentViewerDialog: React.FC<
  DocumentAccompanyingDocumentViewerDialogProps
> = ({
  isViewerDialogOpen,
  setIsViewerDialogOpen,
  docs,
  accompanyingDocument,
  handleToggleHasSeen,
}) => {
  const { t } = useLocales();

  const handleClose = () => {
    if (!accompanyingDocument.seen) {
      handleToggleHasSeen();
    }

    setIsViewerDialogOpen(false);
  };

  return (
    <DocumentViewerDialog
      open={isViewerDialogOpen}
      onClose={handleClose}
      docs={docs}
      title={t('documents.accompanyingDocument', { docName: accompanyingDocument.name })}
    >
      <DialogContentText>
        <Alert severity="info">
          {t('documents.accompanyingDocumentDialogContentText', {
            userName: accompanyingDocument.owner,
            date: new Date(accompanyingDocument.uploadDate).toLocaleString('lt'),
          })}
        </Alert>
      </DialogContentText>
    </DocumentViewerDialog>
  );
};

export default DocumentAccompanyingDocumentViewerDialog;
